import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import PageHero from "../ones/PageHero";
import galleryBannerImg from "../assets/image19.jpeg";
import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import CustomersBanner from "../ones/CustomersBanner";
import GalleryBanner from "../ones/GalleryBanner";
import PageWithSidebar from "../components/PageWithSidebar";

export default function View(props) {
  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..

    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <PageHero
          bgImage={galleryBannerImg} // Au banner yoyote ya kijani/dhahabu inayofaa kama background
          kicker="Maktaba ya Picha"
          heading="Matunzio ya YCSC"
          paragraph="Shuhudia safari yetu ya tangu klabu ya kijamii mwaka 2015 hadi SACCOS thabiti. Tazama kumbukumbu za mikutano makuu, mafunzo na hatua zote za maendeleo chini ya kaulimbiu yetu ya 'Mshikamano Daima'."
        />
        <PageWithSidebar>
          <GalleryBanner />
        </PageWithSidebar>
        <Footer />
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
